import { StandingWinner } from "./standingWinner";

export class RodeoEventStandings {
    eventType: string;
    winners: StandingWinner[] = [];
}


// WEBPACK FOOTER //
// ./src/model/rodeoEventStandings.ts